module.exports = __webpack_public_path__ + "static/tierrawhack-63293c5efacfc5c2871a6291e362f5f3.webm";